import React from 'react'
import {useTranslation} from 'react-i18next'

export default function TableHead() {
  const {t} = useTranslation()

  const headTable = [
    {
      name: t('srNo'),
      class: 'min-w-150px',
    },
    {
      name: t('optionCatleogue'),
      class: 'min-w-150px',
    },
    {
      name: t('optionName'),
      class: 'min-w-150px',
    },
    {
      name: t('optionType'),
      class: 'min-w-150px',
    },
    {
      name: t('status'),
      class: 'min-w-150px',
    },

    {
      name: t('action'),
      class: 'max-w-120px',
    },
  ]

  return (
    <thead>
      <tr
        // style={{display:'flex',justifyContent:'space-between'}}
        className='fw-bold text-muted'
      >
        {headTable.map((e, i) => (
          <th
            style={{
              textAlign: i === 0 ? 'start' : 'start',
              width: i === headTable.length - 1 ? '110px' : 'auto',
            }}
            key={i}
            className={e.class}
          >
            {e.name}
          </th>
        ))}
      </tr>
    </thead>
  )
}
